<template>
    <el-button
        class="searchDrawer btn5"
        icon="el-icon-s-fold"
        type="text"
        size="mini"
        @click="drawerVisible"
        ><slot>高级搜索</slot>
        <div class="line_tl"></div>
        <div class="line_tr"></div>
        <div class="line_bl"></div>
        <div class="line_br"></div>
        <div class="line_all"></div>
    </el-button>
</template>

<script>
export default {
    methods: {
        drawerVisible() {
            this.$emit("update:drawerVisible", true);
        }
    },
};
</script>

<style lang="scss">
</style>
